import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MyApiService } from 'src/app/components/custom/my-api.service';
import { environment } from 'src/app/environment';

@Component({
    selector: 'app-blogs',
    templateUrl: './blogs.component.html',
    styleUrls: ['./blogs.component.scss'],
    standalone: false
})
export class BlogsComponent implements OnInit {
  blogs: any[] = [];
  currentPage = 1;
  totalPages = 1;
  itemsPerPage = 10;
  totalItems = 0;
  searchQuery = '';
  fileBaseUrl = environment.FILE_URL;

  constructor(private readonly apiService: MyApiService,private router: Router) { }

  ngOnInit(): void {    
    this.loadBlogs();
  }

  loadBlogs(page = 1): void {
    const params = {
      pageNo: page,
      limit: this.itemsPerPage,
      search: this.searchQuery
    };

    this.apiService.getBlogs(params).subscribe((res) => {
      this.blogs = res.data.list;
      this.totalItems = res.data.count;
      this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
      this.currentPage = page;
    });
  }

  onPageChange(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.loadBlogs(page);
    }
  }

  onSearch(search: string): void {
    this.searchQuery = search;
    this.loadBlogs(1);
  }
  redirectToBlog(name: string) {
    this.apiService.redirectCourseCategory(name);
  }
  viewblog(blog: any){
    this.router.navigate(['/blogs-details'], { queryParams: { blog_id: blog._id } });
  }
  
}
